import React, { useState, useEffect } from "react";
import "./SettingsComponent.css";
import { useNavigate } from "react-router-dom";
import voprosIcon from "../../../img/vopros.png";
import loadingPng from "../../../img/loading.png"

const SettingsComponent = ({ socket }) => {
  const navigate = useNavigate();
  const defaultText = "Save settings";
  const successText = "Settings saved";
  // Состояния для текстовых полей
  const [past888, setPast888] = useState("");
  const [pastUsername, setPastUsername] = useState("");
  const [buttonText, setButtonText] = useState(defaultText);

  // Загрузка настроек при монтировании компонента
  useEffect(() => {
    if (!socket) {
      console.error("Socket connection is not established");
      return;
    }

    // Отправляем запрос на сервер для получения текущих настроек
    socket.emit("get_settings", (response) => {
      if (response.success) {
        // Устанавливаем полученные значения в состояние
        setPast888(response.data.paste888 || "");
        setPastUsername(response.data.pasteUsername || "");
      } else {
        console.error("Failed to load settings:", response.message);
      }
    });
  }, [socket]);

  // Обработчик сохранения настроек
  const handleSaveSettings = () => {
    if (!socket) {
      console.error("Socket connection is not established");
      return;
    }

    // Отправляем данные на сервер через Socket.IO
    socket.emit("save_settings", {
      past888,
      pastUsername,
    });

    setButtonText(successText);

    // Возвращаем текст к исходному значению через 3 секунды
    setTimeout(() => {
      setButtonText(defaultText);
    }, 3000); // 3000 мс = 3 секунды
  };

  const Tooltip = ({ text }) => {
    const [showTooltip, setShowTooltip] = useState(false);
  
    return (
      <div
        className="tooltipContainer"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <div className="tooltipIcon"><img src={voprosIcon} /></div>
        {showTooltip && <div className="tooltipText">{text}</div>}
      </div>
    );
  };

  return (
    <div className="mainContainer">
      <div className="wrapper">
        <div className="mainSettingsContainer">
          <span className="title">PARSER</span>
          <div className="settingsContainer">
            <div className="settingsTitleContainer">
              <span className="titleParsing">Settings</span>
              <Tooltip text="Для взаимодействия с заготовленной пастой, нужно использовать Hello {{nft}} for sale? (Hello @durov for sale?)" />
            </div>

            <div className="inputGroup">
              <span className="inputLabel">Past @username</span>
              <textarea
                className="inputField"
                placeholder="hello i wanna buy ur +888 for 1000 ton"
                value={pastUsername}
                onChange={(e) => setPastUsername(e.target.value)}
              ></textarea>
            </div>

            <button className="saveButton" onClick={handleSaveSettings}>
              {buttonText}
            </button>

            <button
              className="parserButton"
              onClick={() => navigate("/profile")}
            >
              <img src={loadingPng} />
              Parser
            </button>
            <button
              className="historyButton"
              onClick={() => navigate("/history")}
            >
              History
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


export default SettingsComponent;
